import { loader } from 'graphql.macro';
import makeSchema from 'utils/makeSchema';

const generatedSchema = loader('./generated/schema.graphql');

const schema = makeSchema(generatedSchema);

export default schema;
